import { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import { toast } from 'react-toastify'
import { triggerDashboardPdfExport } from '../services/dashboardPdfService'

const ExportPdfButton = ({ dashboardId, token, baseUrl }) => {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    setIsExporting(true)
    try {
      await triggerDashboardPdfExport({ dashboardId, token, baseUrl })
      toast.success('PDF export queued. The file will be available in Exports shortly.')
    } catch (err) {
      console.error('PDF export failed:', err)
      toast.error('PDF export failed. Please try again.')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button
      variant="light"
      size="sm"
      onClick={handleExport}
      disabled={isExporting}
    >
      {isExporting
        ? <><Spinner animation="border" size="sm" className="me-1" />Exporting...</>
        : 'Export PDF'
      }
    </Button>
  )
}

export default ExportPdfButton
